import React from 'react';

/*
 * One badge for every status in the app, so the same state looks the same on
 * every page. Colours are 800-on-50/100 for WCAG AA contrast.
 *
 *   <StatusBadge status="IN_TRANSIT" />            -> "In transit", amber
 *   <StatusBadge status="APPROVED" label="Live" /> -> custom text, same colour
 */
const TONES = {
  neutral: 'bg-gray-100 text-gray-800 ring-gray-200',
  info: 'bg-sky-50 text-sky-800 ring-sky-200',
  progress: 'bg-violet-50 text-violet-800 ring-violet-200',
  warning: 'bg-amber-50 text-amber-800 ring-amber-200',
  success: 'bg-green-50 text-green-800 ring-green-200',
  danger: 'bg-red-50 text-red-800 ring-red-200',
};

// status -> tone. Group by meaning, not by page.
const STATUS_TONES = {
  // waiting / not started
  DRAFT: 'neutral', PLANNED: 'info', OPEN: 'info', CONFIRMED: 'info', QC_PENDING: 'warning', NOT_SCHEDULED: 'neutral',
  // moving
  APPROVING: 'progress', PARTIAL: 'progress', DISPATCHED: 'progress', IN_TRANSIT: 'warning', SCHEDULED: 'progress',
  // done
  APPROVED: 'success', DELIVERED: 'success', CLOSED: 'success', POSTED: 'success', PROCESSED: 'success', RECEIVED: 'success',
  // stopped
  CANCELLED: 'neutral', REVERSED: 'neutral', SUPERSEDED: 'neutral', DISMISSED: 'neutral',
  // stock health
  HEALTHY: 'success', OK: 'success', LOW: 'warning', AT_RISK: 'warning', REORDER: 'warning',
  CRITICAL: 'danger', OUT_OF_STOCK: 'danger', OVERSTOCK: 'info', ON_TRACK: 'success',
  // alerts
  HIGH: 'danger', MEDIUM: 'warning', INFO: 'info',
};

export const statusTone = (status) => STATUS_TONES[String(status || '').toUpperCase()] || 'neutral';

export const statusLabel = (status) => {
  const text = String(status || '—').replace(/_/g, ' ').toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const StatusBadge = ({ status, label, tone, className = '', ...props }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${TONES[tone || statusTone(status)]} ${className}`}
    {...props}
  >
    {label ?? statusLabel(status)}
  </span>
);

export default StatusBadge;
